/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
export default [
  {
    path: '/dashboard',
    // Relative to /src/views
    view: 'Dashboard'
  },
  {
    path: '/user-profile',
    name: 'User Profile',
    view: 'UserProfile'
  },
  {
    path: '/timesheets',
    name: 'Timesheets',
    view: 'Timesheets',
    props: true
  },
  {
    path: '/admin/timesheets',
    name: 'AdminTimesheets',
    view: 'Timesheets',
    props: true
  },
  {
    path: '/contacts',
    name: 'Contacts',
    view: 'Contacts'
  },
  {
    path: '',
    name: 'Login',
    view: 'Login'
  },
  {
    path: '/admin',
    name: 'Admin',
    view: 'Admin'
  },
  {
    path: '/reports',
    name: 'Reports',
    view: 'Reports'
  },
  {
    path: '/admin/payroll',
    name: 'AdminPayroll',
    view: 'Payroll'
  },
  {
    path: '/admin/clients',
    name: 'AdminClients',
    view: 'Clients'
  },
  {
    path: '/admin/projects',
    name: 'AdminProjects',
    view: 'Projects'
  },
  {
    path: '/admin/activities',
    name: 'AdminActivities',
    view: 'Activities'
  },
  {
    path: '/admin/practices',
    name: 'AdminPractices',
    view: 'Practices'
  },
  {
    path: '/admin/statements',
    name: 'AdminStatements',
    view: 'Statements'
  },
  {
    path: '/admin/master',
    name :'AdminMaster',
    view: 'MasterData'
  },
  {
    path: '/admin/reminders',
    name: 'AdminReminders',
    view: 'Reminders'
  },
  {
    path: '/admin/viewTimesheets',
    name: 'AdminViewTimesheets',
    view: 'ViewTimesheets'
  },
  {
    path: '/admin/summary',
    name: 'AdminTimesheetSummary',
    view: 'SummaryList'
  },
  {
    path: '/admin/userManager',
    name: 'AdminUserManager',
    view: 'UserManager'
  },
  {
    path: '/approval/:type/:approval_id/:secret',
    name: 'Approval',
    view: 'Approval'
  },
  {
    path: '/timesheetApproval',
    name: 'Timesheet Approval',
    view: 'TimesheetApproval'
  },
  {
    path: '/timesheetApproval/submitTimesheets',
    name: 'SubmitTimesheets',
    view: 'SubmitTimesheets',
    props: true
  },
  {
    path: '/timesheetApproval/approvalList',
    name: 'Approval list',
    view: 'ApprovalList'
  },
  {
    path: '/admin/forwardLeavePlanner',
    name: 'Forward Leave Planner',
    view: 'LeaveCalendar'
  },
  {
    path: '/timesheetApproval/viewSubmissions',
    name: 'ViewSubmissions',
    view: 'ViewSubmissions',
    props: true
  }
]
